export default {
  path: '/search-results/:query',
  name: 'search-results',
  component: () => import(/* webpackChunkName: "search-results" */ './SearchResults'),
  props: true,
  meta: {
    requiresAuth: true
  }
}
